const e = {
  name: "PenTool",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M32.8,17.6l-7.1,17.3L2.7,40L0,37.3l5.1-23l17.3-7.1L29.6,0L40,10.4L32.8,17.6z M22.8,9.2L6.9,15.7L2.3,36.3
			L12.5,26c-0.4-0.6-0.6-1.3-0.6-2c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4c-0.7,0-1.4-0.2-2-0.6L3.7,37.7l20.6-4.6
			l6.5-15.9L22.8,9.2z M32,15.6l5.2-5.2l-7.6-7.6L24.4,8L32,15.6z M14,24c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2
			C14.9,22,14,22.9,14,24z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as PenTool
};
